import React, { Component } from "react";
import style from "./CircularProgress.module.scss";
import classnames from "classnames";

class CircularProgress extends Component {
  render() {
    if (this.props.static) {
      return <StaticProgress {...this.props} />;
    } else {
      return <LoadingProgress {...this.props} />;
    }
  }
}

const LoadingProgress = (props) => {
  const classes = props.sm
    ? style.spinner + " " + style.sm
    : props.md
    ? style.spinner + " " + style.md
    : style.spinner;

  return <div className={classes} style={props.style || {}}></div>;
};

const StaticProgress = (props) => {
  const styles = {
    fg: {
      fill: "none",
      stroke: "rgb(64, 179, 22)",
    },
    bg: {
      fill: "none",
      stroke: "rgb(239, 239, 239)",
      transition: "stroke-dashoffset .5s ease-in-out",
    },
    txt: {
      fontSize: "10.5px",
    },
  };

  const { strokeWidth, size, percentage, text } = props;
  const strokeWidthCapped = Math.min(strokeWidth, size / 2 - 1);
  const radius = Math.max((size - strokeWidthCapped) / 2 - 1, 0);
  const circumference = 2 * Math.PI * radius;
  const textStyle = props.textStyle || {};

  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      <circle style={styles.bg} cx={size / 2} cy={size / 2} r={radius} strokeWidth={strokeWidthCapped} />
      <circle
        style={styles.fg}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={strokeWidthCapped}
        strokeDasharray={circumference}
        strokeDashoffset={(1 - (Math.round(percentage) || 0) / 100) * circumference}
      />
      <text
        style={{ ...styles.txt, ...textStyle }}
        transform="rotate(90)"
        x="50%"
        y="-40%"
        textAnchor="middle"
      >
        {text ? text : Math.round(percentage) + "%"}
      </text>
    </svg>
  );
};

export default CircularProgress;
